export const dimensions = {
  topNavHeight: 94,
  sidebarWidth: 352,
  vscrollWidth: '0.5em',
  profileHeight: '30px',
  tabbarHeight: '70px',
  navHeight: '40px',
  contentMaxWidth: '960px',
  chatTitleHeight: '45px',
  chatInputHeight: '60px',
  modalSidePanelWidth: '200px',
  borderRadiusXS: '4px',
  borderRadiusSM: '6px',
  xxBorderRadiusSM: '8px', // this is the border radius matching the new designs. When we complete the migration, we can remove this and rename borderRadiusSM to borderRadiusSM
  borderRadiusMD: '12px',
  borderRadiusLG: '24px',
  borderRadiusCircle: '50%',
}

export const spacing = {
  XS: '2px',
  spacingSM: '4px',
  spacingMD: '8px',
  spacingLG: '12px',
  spacingXL: '16px',
  spacingXXL: '20px',
  spacingXXXL: '24px',
}
